import type { FC } from 'react';
import { STATUS_VARIANTS, statusVariants } from '../../BordStatus.type';
import '../Circle/Circle.scss';

interface ICircleProps {
  variant?: statusVariants;
}

const Circle: FC<ICircleProps> = ({ variant = 'default' }) => {
  const renderVariants = {
    [STATUS_VARIANTS.default]: 'bg-disabled-fg-secondary',
    [STATUS_VARIANTS.informative]: 'bg-nudos-blue',
    [STATUS_VARIANTS.success]: 'bg-nudos-green-300',
    [STATUS_VARIANTS.danger]: 'bg-nudos-red-200',
    [STATUS_VARIANTS.alert]: 'bg-nudos-yellow-200'
  };
  return <div className={`circleContainer ${renderVariants[variant]}`}></div>;
};

export default Circle;
